import apiClient from './client';

export interface DirectJobInviteInfo {
  contractorCompanyName: string;
  jobTitle: string;
  email: string;
}

export async function validateDirectJobInvite(token: string, email: string): Promise<DirectJobInviteInfo> {
  const response = await apiClient.get<DirectJobInviteInfo>('/DirectJobInvite/validate', { params: { token, email } });
  return response.data;
}
